import React, { useState } from "react";
import { Box, Typography, Divider, useTheme } from "@mui/material";
import Header from "../../../components/Header";
import DosagesList from "../../../components/DosagesList";
import TicketsList from "../../../components/TicketsList"; // Import the TicketsList component
import { tokens } from "../../../theme";
import { useNavigate, useParams } from "react-router-dom";
import { useGetTemplateByIdQuery } from "../../../services/templateService";
import ErrorComponent from "../../../components/ErrorComponent";
import LoadingComponent from "../../../components/LoadingComponent";
import { formatDate } from "../../../utils/formatDate";
import SuccessButton from "../../../components/SuccessButton";

const ViewTemplate = () => {
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();
  const colors = tokens(theme.palette.mode);
  const [selectedTicketId, setSelectedTicketId] = useState(null);

  const { data: template, isLoading: isTemplateLoading, error: templateError } = useGetTemplateByIdQuery(id);

  if (isTemplateLoading) {
    return <LoadingComponent />;
  }

  if (templateError) {
    return <ErrorComponent />;
  }

  return (
    <Box m="20px">
      <Header title="Detalles del Plan de Aplicaciones" />

      <Box
        display="grid"
        gap="20px"
        gridTemplateColumns="repeat(2, minmax(0, 1fr))"
      >
        {/* Template Name */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Nombre del Plan
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {template?.name}
          </Typography>
        </Box>

        {/* Template Date */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Fecha de Creación
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {formatDate(template?.date)}
          </Typography>
        </Box>
      </Box>

      {/* Divider */}
      <Divider sx={{ my: "20px", borderColor: colors.grey[700] }} />


      <Box
        display="grid"
        gap="20px"
        gridTemplateColumns="repeat(2, minmax(0, 1fr))"
      >
      
        {/* Tickets Section */}
        <Box>
          <Typography variant="h5" fontWeight="bold" mb="16px" color={colors.grey[100]}>
            Tickets
          </Typography>
          <TicketsList ticketsList={template?.tickets} setSelectedTicket={setSelectedTicketId} isReadOnly />
        </Box>

        {/* Dosages Section */}
        <Box>
          <Typography variant="h5" fontWeight="bold" mb="16px" color={colors.grey[100]}>
            Dosificación
          </Typography>
          {selectedTicketId ? (
            <DosagesList ticketId={selectedTicketId} isReadOnly />
          ) : (
            <Typography variant="h4" fontWeight="bold" color={colors.greenAccent[500]} textAlign="center">
              Selecciona un ticket para ver la dosificación
            </Typography>
          )}
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="end"
        gap="4px"
      >
        <SuccessButton label="Ver Planes" onClick={() => navigate('/templates')}/>
      </Box>
    </Box>
  );
};

export default ViewTemplate;